/* istanbul ignore file */
/* eslint-disable */
// Google analytics script
window.dataLayer = window.dataLayer || [];
export function googleAnalytics(i, s, o, g, r, a?: any, m?: any) {
  i.GoogleAnalyticsObject = r;
  ((i[r] =
    i[r] ||
    function () {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * (new Date() as any)));
  ((a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]));
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
}
